export default "__VITE_ASSET__BEr9urmh__"